import { ReactNode } from "react";
import timeImage from "../assets/images/image1.png";
import scoreImage from "../assets/images/image3.png";
import levelImage from "../assets/images/image2.png";
import Text from "../../../components/ui/Text";

type GameProgressProps = {
  /**
   * Time left in seconds.
   * If omitted, component will use hook's timeLeft.
   */
  attempts?: number;
  /**
   * Points / score to display.
   * If omitted, component will use hook's score.
   */
  points?: number;
  /**
   * Current level stage number.
   * If omitted, component will use hook's level.
   */
  levelStage?: number;
  /**
   * Optional callback to reset the game.
   * If omitted, component will use hook.resetGame.
   */
  onReset?: () => void;
  /**
   * Optional callback to force next level.
   * If omitted, component will use hook.forceNextLevel.
   */
  onNextLevel?: () => void;
  /**
   * Optionally pass running / game over state. Otherwise read from hook.
   */
  isRunning?: boolean;
  isGameOver?: boolean;
  className?: string;
};

interface StatCardProps {
  label: string;
  value: ReactNode;
  iconImage: string;
  className?: string;
  imgClassName?: string;
}

const StatCard = ({
  label,
  value,
  iconImage,
  className = "",
  imgClassName = "",
}: StatCardProps) => {
  return (
    <div
      className={`rounded-[7px] drop-shadow-sm pl-0 p-3 h-[50px] relative flex items-center overflow-hidden ${className}`}
    >
      <img
        src={iconImage}
        alt="icon"
        className={`max-w-[37px] max-h-[37px] object-contain mr-1 ${imgClassName}`}
      />
      <Text
        size="md"
        className="uppercase text-white bebas-neue-font !font-semibold mr-1"
      >
        {label}
      </Text>

      <div className="bg-gradient-to-r from-white/10 to-white/5 px-3 py-1 min-w-[50px] flex items-center justify-center text-center h-[30px] rounded-md ml-auto">
        <Text className="gilroy-font text-white" size="xxs">
          {value}
        </Text>
      </div>
    </div>
  );
};

export default function GameProgress({
  attempts,
  points,
  levelStage,
  className = "",
}: GameProgressProps) {
  return (
    <div
      className={`flex items-start justify-between space-x-3 w-full ${className}`}
    >
      <StatCard
        label="Attempts"
        value={attempts}
        iconImage={timeImage}
        className="flex-1 bg-gradient-to-r from-[#125a2a] to-[#174025] min-w-[190px]"
      />
      <StatCard
        label="Score Statistics"
        value={`${points} Points`}
        iconImage={scoreImage}
        className="flex-[2] bg-gradient-to-r from-[#58186b] to-[#442249] min-w-[260px]"
      />
      <StatCard
        label="Level Stage"
        value={levelStage}
        iconImage={levelImage}
        imgClassName=""
        className="flex-1 bg-gradient-to-r from-[#144966] to-[#15354a] min-w-[190px]"
      />
    </div>
  );
}
